import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { copyInquiryPrice, editInquiryPriceStatus, queryInquiryPrice } from '@/api/price/inquiry'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryCompanyUserByCompany, queryUserRoleByCompany } from '@/api/company'
import { getInquiryCustomerByRole } from '@/api/booking/job'
import { cache } from '@/utils/cacheManager'
import { Company } from '@/class/model/mdm/Company'

export default {
  methods: {
    // 打印按钮触发事件
    toPrint() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      this.templateSelectorDialog.data.INQUIRY_PRICE_UUID = this.selectedRows.map(row => row.uuid)
      console.log('this.templateSelectorDialog.data.INQUIRY_PRICE_UUID:', this.templateSelectorDialog.data.INQUIRY_PRICE_UUID)
      this.templateSelectorDialog.visible = true
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },

    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
      this.detail()
    },

    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.departmentId = this.$store.getters.currentDeptId
      queryInquiryPrice(this.filter).then(res => {
        this.rowData = res.data.list
        this.gridApi.refreshCells({ force: true })
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRow = null
        this.selectedRows = []
      }).finally(() => {
        this.loading.close()
      })
    },

    detail() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.inquiryDetail.originForm = this.selectedRow
        this.$refs.inquiryDetail.form = this.selectedRow
        this.$refs.inquiryDetail.init()
        this.loadSalesPrivateCustomer()
      })
    },

    edit() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.inquiryDetail.isEdit = true
        this.$refs.inquiryDetail.originForm = this.selectedRow
        this.$refs.inquiryDetail.form = deepClone(this.selectedRow)
        this.$refs.inquiryDetail.init()
        this.loadSalesPrivateCustomer()
      })
    },

    back() {
      this.view = 'list'
      this.queryHandler()
    },

    add() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.inquiryDetail.isEdit = true
        this.loadSalesPrivateCustomer()
      })
    },

    // 下架
    revoke() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      // this.filter.branchId = this.$store.getters.currentOfficeId
      const row = this.selectedRows.find(p => p.status === SystemConstants.INQUIRY_STATUS_DRAFT.code ||
          [SystemConstants.QUOTE_STATUS_QUOTED.code, SystemConstants.QUOTE_STATUS_REJECTED.code].indexOf(p.prePortQuotationStatus) > -1 ||
          [SystemConstants.QUOTE_STATUS_QUOTED.code, SystemConstants.QUOTE_STATUS_REJECTED.code].indexOf(p.trunkLineQuotationStatus) > -1 ||
          [SystemConstants.QUOTE_STATUS_QUOTED.code, SystemConstants.QUOTE_STATUS_REJECTED.code].indexOf(p.lastMileQuotationStatus) > -1)
      if (row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectPendingQuoteSubmittedCancel'))
        return
      }
      this.loading = getLoading4Cxt()
      editInquiryPriceStatus({
        inquiryPriceUuids: this.selectedRows.map(p => p.uuid),
        action: SystemConstants.INQUIRY_ACTION_REVOKE.code
      }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    copy() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectInquiryToCopy'))
        return
      }
      this.loading = getLoading4Cxt()
      copyInquiryPrice({
        inquiryPriceUuids: this.selectedRows.map(p => p.uuid)
      }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    init() {
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
    },
    // 外部销售只能加载自己的客户
    async loadSalesPrivateCustomer() {
      if (this.view === 'detail' && this.accountObjectControlMode !== 2) {
        this.$refs.inquiryDetail.customerCmpList = null
        const companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
        const branch = this.form && this.form.uuid ? this.form.salesOffice : this.$store.getters.currentOfficeId
        const department = this.form && this.form.uuid ? this.form.salesDepartment : this.$store.getters.currentDeptId
        // 查看所有销售的客户
        if (this.$checkPermission(['role_Inquiry_allCustomer']) || this.$store.getters.isAdmin) {
          await queryUserRoleByCompany({ branch, roleType: 2, lob: 'SE' }).then(res => {
            this.$refs.inquiryDetail.customerCmpList = companyList.filter(p => res.data.includes(p.uuid))
          })
        } else if (this.$checkPermission(['role_Inquiry_departmentCustomer'])) {
          await getInquiryCustomerByRole({ branch, department }).then(res => {
            this.$refs.inquiryDetail.customerCmpList = companyList.filter(p => res.data.includes(p.cmpIdx))
          })
        } else {
          // 默认查看个人
          await queryUserRoleByCompany({ branch, userId: this.$store.getters.userId, roleType: 2, lob: 'SE' }).then(res => {
            this.$refs.inquiryDetail.customerCmpList = companyList.filter(p => res.data.includes(p.uuid))
          })
        }
        // CARGO-53554  一、二两点注释掉暂时不发
        // if (this.isHc) {
        //   // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
        //   this.$refs.inquiryDetail.customerCmpList = await Company.unionAllUserRoleCompany(branch, this.$store.getters.userId, 'SE', this.$refs.inquiryDetail.customerCmpList, companyList)
        // }
      }
    }
  }
}
